// Qué fichas muestra el selector de fuentes ("Elegí qué agregar") en una pestaña:
// las que no están ya en el chat, filtradas por nombre y, en Productos, en el orden
// elegido (ADR-2026-09-25-el-selector-de-fuentes-toma-la-biblioteca).
//
// Puro y sin React: es lo que se testea. El orden es el MISMO de los pickers de
// productos de los modos (`sortProducts`), así "Últimos utilizados" quiere decir lo mismo
// en toda la app.

import type { ChatAttachment } from '../../pages/v2/agentAttachments';
import { sortProducts, type ProductCatalogSort } from '../../pages/v2/productCatalogFilter';
import { yaAdjunto } from './bibliotecaDeAdjuntos';
import type { PestanaBiblioteca } from './bibliotecaDeAdjuntos';
import type { FichaDeFuente } from './useFuentesDeAdjuntos';

/** Las pestañas cuyas fichas tienen nombre: se busca por él y se muestra debajo de la
 *  miniatura. Creaciones y Subidas no lo tienen, y Moodboards no es una grilla plana. */
export const PESTANAS_CON_NOMBRE: ReadonlySet<PestanaBiblioteca> = new Set([
  'productos',
  'modelos',
  'poses',
  'fondos',
]);

export const tieneNombres = (pestana: PestanaBiblioteca): boolean =>
  PESTANAS_CON_NOMBRE.has(pestana);

export function fichasVisibles(
  fichas: FichaDeFuente[],
  opciones: {
    pestana: PestanaBiblioteca;
    adjuntos: ChatAttachment[];
    busqueda: string;
    /** Sólo cuenta en Productos: el resto de las fuentes no tiene fecha de uso. */
    orden: ProductCatalogSort;
  },
): FichaDeFuente[] {
  const filtro = opciones.busqueda.trim().toLowerCase();
  // Lo adjunto no está en la grilla: ya es un chip en la caja.
  const disponibles = fichas.filter((f) => !yaAdjunto(opciones.adjuntos, f.adjunto));
  const buscadas =
    filtro && tieneNombres(opciones.pestana)
      ? disponibles.filter((f) => (f.nombre ?? '').toLowerCase().includes(filtro))
      : disponibles;
  if (opciones.pestana !== 'productos') return buscadas;
  return sortProducts(
    buscadas.map((f) => ({ ...f, lastUsedAt: f.usadoEl ?? null })),
    opciones.orden,
  ).map(({ lastUsedAt: _omitido, ...f }) => f);
}
